export default {
  EMAIL: 'email-address',
  PHONE: 'phone-pad',
  DEFAULT: 'default'
};